const redirectsApi = ({ apiClient }) => ({
  show() {
    return apiClient.get(`real-estates/redirects`)
  },
  put(payload) {
    return apiClient.put(`real-estates/redirects`, { redirects: payload })
  },
})

export default redirectsApi
